import { apiClient } from '@/shared/data/client';
import type { QueryResult, RegisterInterestDto } from '@flowqa/shared';

type RegisterInterestQueryInput = {
  page: number;
  pageSize: number;
  filters?: Array<{ field: string; operator: string; value: unknown }>;
  sorts?: Array<{ field: string; direction: 'asc' | 'desc' }>;
};

export const queryRegisterInterest = async (
  input: RegisterInterestQueryInput,
  token?: string | null,
): Promise<QueryResult<RegisterInterestDto>> => {
  return await apiClient.post<QueryResult<RegisterInterestDto>>(
    'superuser/register-interest/query',
    input,
    { token },
  );
};
